// Copyright (c) 2018 Deere & Company

import InformationRequestForm from '../state/information-request-form';
import actions from '../actions-list';
import {getDefaultState} from '../state';

const addFile = (state, action) =>
    InformationRequestForm.update(state, {
        files: {
            $push: [action.file]
        }
    });

const updateFile = (state, action) =>
    InformationRequestForm.update(state, {
        files: {
            $set: action.files
        }
    });

const resetForm = state =>
    InformationRequestForm.update(state, {
        $set: getDefaultState().informationRequestForm
    });

const updateInfoRequestForm = (state, action) =>
    InformationRequestForm.update(state, {
        $set: action.infoRequestForm
    });

const updateAnswer = (state, action) => {

    const indexToUpdate = action.questions.findIndex(item => item.id === action.questionId);

    return InformationRequestForm.update(state, {
        questions: {
            [indexToUpdate]: {
                answer: {
                    $set: action.answer
                }
            }
        }
    });

};

const updateComments = (state, action) =>
    InformationRequestForm.update(state, {
        courierInfo: {
            comments: {
                $set: action.comments
            }
        }
    });

const updateReturnStatus = (state, action) =>
    InformationRequestForm.update(state, {
        returnStatus: {
            $set: action.returnStatus
        }
    });

export default (state = getDefaultState().informationRequestForm, action) => {

    const actionHandlers = {
        [actions.ADD_REQUEST_DETAILS_INFO_REQUEST_FORM_FILE]: addFile,
        [actions.RESET_REQUEST_DETAILS]: resetForm,
        [actions.UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM]: updateInfoRequestForm,
        [actions.UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM_ANSWER]: updateAnswer,
        [actions.UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM_COMMENTS]: updateComments,
        [actions.UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM_FILE]: updateFile,
        [actions.UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM_RETURN_STATUS]: updateReturnStatus
    };

    const reducer = actionHandlers[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/part-requests/request-details/reducers/information-request-form.js